// extracted by mini-css-extract-plugin
export var active = "DropdownNav-module--active--74809";
export var container = "DropdownNav-module--container--e5427";
export var emoji = "DropdownNav-module--emoji--8aa53";
export var item = "DropdownNav-module--item--62f18";
export var rightAligned = "DropdownNav-module--rightAligned--9a231";